import React from "react";
import { Link } from "react-router-dom";
import Floaticons from "./Floaticons";
import MenuNavbar from "./MenuNavbar";
import "./IndustryTab.css";


function IndustryTab(){

    return(
        <>
            <Floaticons/>
            <div className="banner-container">
                <img src="images/Banner1.png" alt="banner" className="banner-img" />
                <MenuNavbar/>
            </div>
            <div className="Industy_container">
                <h2 className="Industry_head">
                    Industry Learning Academy
                </h2>
                <p className="Industry_content">
                    Industry knowledge is at the crux of understanding a client's business better. Invest in upgrading your Industry Quotient to provide innovative solutions and build client value creation. Industry security learning academy will help you understand how Accenture delivers Industry-specific Secure solutions to its clients. These courses are tagged to the employees who have completed the Industry Foundation and Industry Applied sections of the respective Industry and are all set to explore the Industry aligned security solutions, case studies, and learning paths.
                    <a href="https://atci.lkm-securitylearnings.accenture.com/IndustryLearningAcademy/" target="_blank" activeClassName="active-menu-item">
                    Know More
                    </a>
                </p>
            </div>
        </>
    );
}

export default IndustryTab;